<template>
  <div id="myheader" class="componentBackgroundColor">
    <div class="headerWrap">
      <div class="headerLeft">
        <div class="logoImg">
          <img :src="BASEURL+'static/logo.png'" height="26px">
        </div>
        <div class="logoTitle">{{ APP_WINNY_NAME }}</div>
        <div class="line"></div>
        <div class="headerTitle">
          <a v-for="item of APP_TITLELINKS" :key="item.url" :href="item.url+userInfo" target="_blank">
            {{ item.title }}
          </a>
        </div>
        <div 
          v-if="item.isShow && (item.id > 1 || queryTradeAuthArrGetter.length > 0)" 
          class="headerTitle" 
          :class="$route.path.includes(item.path) || ($route.query.activePath && $route.query.activePath.includes(item.path)) ? 'activeTitle' : ''" 
          v-for="item in titleList" :key="item.id"
          >
          <span @click="toPage(item)">
            {{ item.title }}
          </span>
        </div>
      </div>
      <div class="headerRight">
        <div class="rightIcon">
          <el-dropdown @command="handleCommand">
            <div>
              <img src="../../../assets/images/user.png" alt="">
            </div>
            <el-dropdown-menu slot="dropdown" class="userDropdown">
              <div class="cellphone">
                {{
                sessionInfoGetter.tel
                  ? sessionInfoGetter.tel.slice(0, 3) +
                    '****' +
                    sessionInfoGetter.tel.slice(7, 11)
                  : '--'
                }}
              </div>
              <el-dropdown-item command="1">
                <img src="../../../assets/images/userInfo.png" alt="">
                <div class="itemTitle">个人信息</div>
              </el-dropdown-item>
              <el-dropdown-item command="2">
                <img src="../../../assets/images/changePwd.png" alt="">
                <div class="itemTitle">修改登录密码</div>
              </el-dropdown-item>
              <el-dropdown-item 
                v-if="isSign"
                command="3">
                <img src="../../../assets/images/changeMoneyPwd.png" alt="">
                <div class="itemTitle">修改资金密码</div>
              </el-dropdown-item>
              <el-dropdown-item
                v-if="isOpen"
                command="4">
                <img src="../../../assets/images/changePhone.png" alt="">
                <div class="itemTitle">更换手机号码</div>
              </el-dropdown-item>
              <el-dropdown-item v-if="isShowSub" command="5">
                <img src="../../../assets/images/qyqqsq.png" alt="">
                <div class="itemTitle">补充信息</div>
              </el-dropdown-item>
              <el-dropdown-item v-if="isShowYq" command="6">
                <img src="../../../assets/images/qyqqsq.png" alt="">
                <div class="itemTitle">延期申请</div>
              </el-dropdown-item>
              <el-dropdown-item command="7">
                <img src="../../../assets/images/logout.png" alt="">
                <div class="itemTitle">退出登录</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="rightIcon" @click="$router.push('/mail')">
          <img src="../../../assets/images/notice.png" alt="">
        </div>
        <div class="rightIcon" @click="setDialogShow">
          <img src="../../../assets/images/set.png" alt="">
        </div>
        <div class="rightIcon">
          <el-tooltip placement="top" effect="light">
            <div slot="content" class="QRcode">
              <p class="codeTitle">扫码下载APP</p>
              <img v-if="APP_TITLE_ALL === '云茶茗汇'" src="../../../assets/images/southeast.png" alt="" width="198px">
              <img v-else :src="BASEURL+'static/downLoadCode1.png'" alt="" width="198px">
            </div>
            <img src="../../../assets/images/download.png" alt="">
          </el-tooltip>
        </div>
        <div class="rightTitle" v-if="APP_WINNY_NAME !== '景陶易购'">
          {{ APP_hotline }}
        </div>
      </div>
    </div>
    <changePwdDialog ref="changePwdDialog" />
    <changeMPwdDialog ref="changeMPwdDialog" />
    <changePhoneDialog ref="changePhoneDialog" />
    <supInfo ref="supInfo" />
    <applyExte ref="applyExte" />
    <setDialog ref="setDialog" />
    <el-dialog
      title="个人消息"
      :visible.sync="dialogVisible"
      width="500px"
      center
      :show-close="false"
      :before-close="handleClose"
    >
      <p v-if="formData.type == 1" class="tipHeight">
        根据测试订单购销风险控制管理细则，
        您账户的资金风险率高于100%，在电话通知和短信提醒后，未能自行减少订货量或尽快补足可用资金，现于{{
          formData.tradeDay
        }}将您{{ formData.commodityInfo
        }}{{ formData.bsFlag == 1 ? '买' : '卖' }}方向的{{
          formData.quantity
        }}手持单以{{ formData.price }}在{{
          formData.transferTime | dateFormate
        }}进行代为转让操作，请悉知。
      </p>
      <p v-else class="tipHeight">
        <p v-html="formData.note"></p>
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/*global protocol http util hqWs hqProtocol*/
import { mapGetters } from 'vuex'
import applyExte from '../../../views/userCenterNew/tab/applyExte.vue'
import changePwdDialog from '../../../views/userCenterNew/tab/changePwdDialog.vue'
import changeMPwdDialog from '../../../views/userCenterNew/tab/changeMPwdDialog.vue'
import changePhoneDialog from '../../../views/userCenterNew/tab/changePhoneDialog.vue'

import supInfo from '../../../views/userCenterNew/tab/supInfo.vue'
import setDialog from '../../../components/base/dialog/setDialog.vue'

export default {
  name: 'Header',
  components: {
    changePwdDialog,
    changeMPwdDialog,
    changePhoneDialog,
    supInfo,
    applyExte,
    setDialog
  },
  data() {
    return {
      APP_TITLELINKS: window.g.APP_TITLELINKS || [], // 跳转
      APP_TITLE_ALL: window.g.APP_TITLE_ALL,
      titleList: [
        {
          id: 0,
          title: '行情列表',
          path: '/quotationList',
          isShow: true, // 是否展示
          isLimit: false // 是否需要实名签约
        },
        {
          id: 1,
          title: '现货订单',
          path: '/transcc',
          isShow: true, // 是否展示
          isLimit: false // 是否需要实名签约
        },
        {
          id: 2,
          title: '资金管理',
          path: '/myAssetNew',
          isShow: true, // 是否展示
          isLimit: true // 是否需要实名签约
        },
        {
          id: 3,
          title: '报表系统',
          path: '/reportSystem',
          isShow: true, // 是否展示
          isLimit: true // 是否需要实名签约
        },
        {
          id: 4,
          title: '仓单系统',
          path: '/warehouseSys',
          isShow: true, // 是否展示
          isLimit: true // 是否需要实名签约
        },
        {
          id: 5,
          title: '交收系统',
          path: '/settlementSystem',
          isShow: !!window.g.SETTLEMENT_SYSTEM, // 是否展示
          isLimit: true // 是否需要实名签约
        }
      ],
      APP_hotline: window.g.APP_hotline,
      userInfo: '',
      isShowSub: false, // 是否展示补充信息
      isShowYq: false, // 是否展示延期申请
      isResponse: false,
      isOpen: false, // 是否开户
      isSign: false, // 是否签约
      msgSpanCss: {
        MidLongTermSpanCss: 5,
        LoginSpanCss: 5
      },
      fuAccountFunds: {
        balance: 0,
        frozenFunds: 0
      },
      downLoadCss: false,
      marketStatus: '--',
      systemTime: new Date(),
      runloopTimer: null,
      isFirstT: true,
      isFirstN: true,
      risk: 9999.99, // 风险率 以%为单位
      riskTimer: null,
      BASEURL: process.env.BASE_URL,
      SYSTIME: null,
      counter: 0, // 风险率 我的权益轮询计数器
      RiskRightTimer: null, // 风险率 我的权益轮询定时器
      isRiskRight: false, // 可用资金计算顺序
      holdData: [],
      runloopTimerStatus: true, // 心跳是否继续轮询
      APP_WINNY_NAME: window.g.APP_WINNY_NAME,
      dataList: [], // 站内信信息
      dialogVisible: false,
      formData: {
        type: null, // 1 跟原来处理一样，拼字段   其他的取接口返回的note
        tradeDay: null,
        commodityInfo: '',
        bsFlag: null,
        quantity: '',
        price: '',
        transferTime: null,
        note: null
      } // 站内信具体的每一条数据
    }
  },

  computed: {
    ...mapGetters([
      'sessionInfoGetter',
      'h_orderTime',
      'marketStatusGetter',
      'queryTradeAuthArrGetter',
      'marketDetails',
      'marketStatusInNewTopline',
      'isSignGetter'
    ]),
    SisLogin() {
      return this.sessionInfoGetter.isLogin
    },
    currentSatus() {
      return this.marketStatusGetter.status
    }
  },
  watch: {
    currentSatus(val, oldVal) {
      if (val === 'O') {
        this.$store.commit('clearPriceDetail', [])
        hqWs.send(hqProtocol.param_SYMBOLS)
      }
    },
    // 委托
    h_orderTime(val, oldVal) {
      if (val != oldVal) {
        const _this = this
        _this.counter++
      }
    },
    'fuAccountFunds.balance': {
      handler(val, oldVal) {
        if (val != oldVal) {
          const _this = this
          _this.counter++
        }
      },
      deep: true
    },
    'fuAccountFunds.frozenFunds': {
      handler(val, oldVal) {
        if (val != oldVal) {
          const _this = this
          _this.counter++
        }
      },
      deep: true
    },
    marketDetails: {
      handler(val, oldVal) {
        if (val != oldVal) {
          const _this = this
          if (!this.isRiskRight) {
            _this.counter++
          }
        }
      },
      deep: true
    },
    SisLogin(val) {
      if (val && this.marketStatus === '开市中') {
        this.prePay()
      }
    },
    marketStatus(val) {
      if (val === '开市中' && this.SisLogin) {
        this.prePay()
      }
    }
  },
  mounted() {
    if (this.sessionInfoGetter.isLogin == 'true') {
      this.findUserStatusProcess()
      this.userInfo = '?userId=' + this.sessionInfoGetter.userId + '&firmId=' + this.sessionInfoGetter.firmId +
            '&sessionStr=' + this.sessionInfoGetter.sessionStr +
              '&tel=' + localStorage.getItem('myPhone') + '&equipmentFlag=' + localStorage.getItem('equipmentFlag_PC') || 4
    }
    if (localStorage.lang) {
      // localStorage.lang = localStorage.lang
    } else {
      localStorage.lang = 'cn'
    }
    this.queryTradeClosepl()
    const that = this
    this.RiskRightTimer = setInterval(() => {
      if (that.counter) {
        that.counter = 0
        if (this.sessionInfoGetter?.isLogin == 'true') {
          this.showData()
        }
      }
    }, window.g.Risk_Right_Time ? window.g.Risk_Right_Time : 1000)
    // 预埋单
    if (this.sessionInfoGetter?.isLogin == 'true' && this.marketStatus === '开市中') {
      this.prePay()
    }
  },
  beforeDestroy() {
    if (this.riskTimer) {
      clearInterval(this.riskTimer)
      this.riskTimer = null
    }
    if (this.RiskRightTimer) {
      clearInterval(this.RiskRightTimer)
      this.RiskRightTimer = null
    }
    if (this.runloopTimer) {
      clearTimeout(this.runloopTimer)
      this.runloopTimer = null
    }
    this.runloopTimerStatus = false
  },
  methods: {
    // 显示设置弹窗
    setDialogShow() {
      this.$refs.setDialog.showDialog()
    },
    goTranscc() {
      this.$message('暂无关联商品')
    },
    // 根据状态跳转
    toPage(item) {
      // 需要实名和签约的节点
      if (item.isLimit) {
        //防止实名和签约接口还未返回时 跳转页面
        if (this.isResponse) {
          // 是否实名
          if (this.isOpen) {
            // 是否签约
              if (this.isSign || this.isSignGetter) {
                  this.$router.push(item.path)
            } else {
              this.$router.push({
                path: '/noSign',
                query: {
                  activePath: item.path // 跳转到未签约的页面时也能看出来是点哪个菜单跳到的
                }
              })
              // this.$router.push('/noSign')
            }
          } else {
            this.$router.push({
              path: '/noOpen',
              query: {
                activePath: item.path // 跳转到未开户的页面时也能看出来是点哪个菜单跳到的
              }
            })
          }
        } else {
          this.$message('加载中...')
          const that = this
          setTimeout(function() {
            that.findUserStatusProcess1(item)
          }, 2000)
        }
      } else {
        this.$router.push(item.path)
      }
      // this.$router.push(item.path)
    },
    // 查询用户状态 isAudit  pOro
    findUserStatusProcess() {
      http.postFront(protocol.param_findUserStatusProcess).then(response => {
        const { code, message, value } = response.data
      this.isResponse = true
        if (code === 0 || code === '0') {
          this.$store.commit('setUserCateInfo', value)
          if (value && value.audit) {
            // 代表已开户 true   false代表未开户
            this.isOpen = true
            if (value.poro === 'P' && window.g.isSupInfo) {
              // this.isShowSub = true
              this.queryComStatus()
            }
            this.querySignStatus()
          } else {
            this.isOpen = false
            this.isSign = false
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 查询用户状态
    findUserStatusProcess1(item) {
      http.postFront(protocol.param_findUserStatusProcess).then(response => {
        const { code, message, value } = response.data
        this.isResponse = true
        if (code === 0 || code === '0') {
          this.$store.commit('setUserCateInfo', value)
          if (value && value.audit) {
            this.isOpen = true
            this.querySignStatus1(item)
          } else {
            this.isOpen = false
            this.isSign = false
            this.toPage(item)
          }
          // 开户 签约 入金 交易 下单 未知
        } else {
          this.$message(message)
        }
      })
    },
    // 查询补充认证信息 只要有审核通过的就不展示了
    queryComStatus() {
      // http.postFrontMarket0(protocol.param_queryUserCompanyInformation).then((response) => {
      //   const { code, message, value } = response.data
      //   if (Number(code) === 0) {
      //     if (value && value.companyAuditStatus === 1) {
      //       this.isShowSub = false
      //     } else {
      //       this.isShowSub = true
      //     }
      //     // 查询状态
      //   } else {
      //     this.$message(message)
      //   }
      // })
      http.postFrontMarket0(protocol.param_queryUserDelayAudit).then((response) => {
        const { code, message, value } = response.data
        if (Number(code) === 0) {
          if (value.state) { // 为真表示有待审核和审核通过的
            if (value.delay) {
              this.isShowSub = true
              if (value.delay.signatureAuditStatus != 1) {
                this.isShowYq = true
              }
            }
            if (value.company) {
              if (value.companyAuditStatus != 1) {
                this.isShowSub = true
              } else {
                this.isShowSub = false
              }
            }
          } else {
            this.isShowSub = true
            this.getDeaDay()
          }
          // 查询状态
        } else {
          this.$message(message)
        }
      })
    },
    getDeaDay() {
      http.postFrontMarket0(protocol.param_queryUserCreateTimeAndDeadline).then((response) => {
        var { code, value, message } = response.data
        if (Number(code) === 0) {
          // 只计算到天
          const curtime = new Date(new Date().toLocaleDateString()).getTime() // 当天零点
          const regtime = new Date(value.createTime.slice(0, 10) + ' 00:00:00').getTime() // 注册零点
          const day = (curtime - regtime) / 1000 / 60 / 60 / 24
          if (value.allowTradeDayNum <= day) {
            // 过了补充信息期限
            this.isShowYq = true
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 查询认证信息
    querySignStatus() {
      // 签约状态 0未签约, 1已签约, 2已解约, 5签约失败, 13签约在途
      protocol.param_findBankInfo.param.bankId = window.g.Bank_Id
      http.postFrontMarket0(protocol.param_findBankInfo).then((response) => {
        const { code, message, value } = response.data
        if (Number(code) === 0) {
          if (value) {
            if (value.signFlag == 1) {
              this.$store.commit('setIsSign', true)
              this.isSign = true
            } else {
              this.$store.commit('setIsSign', false)
              this.isSign = false
            }
          } else {
            this.$store.commit('setIsSign', false)
            this.isSign = false
          }
          // 查询状态
        } else {
          this.$message(message)
        }
      })
    },
    // 查询认证信息
    querySignStatus1(item) {
      // 签约状态 0未签约, 1已签约, 2已解约, 5签约失败, 13签约在途
      protocol.param_findBankInfo.param.bankId = window.g.Bank_Id
      http.postFrontMarket0(protocol.param_findBankInfo).then((response) => {
        const { code, message, value } = response.data
        if (Number(code) === 0) {
          if (value) {
            if (value.signFlag == 1) {
              this.$store.commit('setIsSign', true)
              this.isSign = true
            } else {
              this.$store.commit('setIsSign', false)
              this.isSign = false
            }
          } else {
            this.$store.commit('setIsSign', false)
            this.isSign = false
          }
          this.toPage(item)
          // 查询状态
        } else {
          this.$message(message)
        }
      })
    },
    handleCommand(val) {
      if (val == 1) {
        // 跳转个人信息
        this.$router.push('/personInfo')
      } else if (val == 2) {
        // 跳转修改密码
        this.$refs.changePwdDialog.showDialog()
      } else if (val == 3) {
        // 跳转修改资金密码
        this.$refs.changeMPwdDialog.showDialog()
      } else if (val == 4) {
        // 跳转修改手机号
        this.$refs.changePhoneDialog.showDialog()
      } else if (val == 5) {
      // 跳转补充信息
        this.$refs.supInfo.showDialog()
      } else if (val == 6) {
      // 跳转延期申请
        this.$refs.applyExte.showDialog()
      } else if (val == 7) {
        this.logout()
      }
    },
    /**
     * 预埋单处理
     */
    prePay() {
      let PrePayArr = []
      const obj = JSON.parse(
        localStorage.getItem(`PrePay${this.sessionInfoGetter.tel}`)
      )
      try {
        if (obj && obj.length > 0) {
          PrePayArr = obj
        }
      } catch (error) {}
      if (PrePayArr.length > 0) {
        this.$message({ message: '开始执行预埋单', duration: 1000 })
      }
      while (PrePayArr.length > 0) {
        const postData = PrePayArr.shift()
        http.postFront(postData).then(response => {
          // this.$message({ message: response.data.message, duration: 1000 })
        })
      }
      localStorage.setItem(
        `PrePay${this.sessionInfoGetter.tel}`,
        JSON.stringify(PrePayArr)
      )
    },
    // 查询当前交易id
    async queryTradeClosepl() {
      if (
        sessionStorage.getItem('sessionStr') &&
        sessionStorage.getItem('userId')
      ) {
        http.postFront(protocol.param_v2_queryTradeClosepl).then(async(response) => {
          const { code, value } = response.data
          if (Number(code) === 0) {
            if (value) {
              if (this.dataList.length === 0 && value.readFlag && this.isSureLoginMsg()) {
                this.isReadFlag()
              }
              this.param_queryContentSystem(value.contentSystem)
              this.$store.commit('setH_holdTime', value.holdTime) // 持仓汇总更新时间
              this.$store.commit('setH_orderTime', value.orderTime) // 委托更新时间
              this.$store.commit('setH_tradeTime', value.tradeTime) // 成交更新时间
              if (value.fuAccountFunds) {
                this.fuAccountFunds = {
                  balance: value.fuAccountFunds.balance,
                  frozenFunds: value.fuAccountFunds.frozenFunds
                }
              } else {
                this.fuAccountFunds = {
                  balance: 0,
                  frozenFunds: 0
                }
              }
              if (this.isFirstT) {
                this.isFirstT = false
              }
              await this.runloopQueryTradeClosepl()
            } else {
              this.fuAccountFunds = {
                balance: 0,
                frozenFunds: 0
              }
            }
            this.showData()
          } else {
            this.isFirstT = true
            await this.runloopQueryTradeClosepl()
          }
        })
      } else {
        this.isFirstT = true
        await this.runloopQueryTradeClosepl()
      }
    },
    async runloopQueryTradeClosepl() {
      const that = this
      if (this.runloopTimer) {
        clearTimeout(this.runloopTimer)
        this.runloopTimer = null
      }
      if (JSON.parse(sessionStorage.getItem('isLogin'))) {
        try {
          const response = await http.postFront(protocol.param_v2_queryTradeClosepl)
          const { code, value } = response.data
          if (code == '0') {
            if (value) {
              if (this.dataList.length === 0 && value.readFlag && this.isSureLoginMsg()) {
                this.isReadFlag()
              }
              setTimeout(() => {
                this.param_queryContentSystem(value.contentSystem)
                this.$store.commit('setH_holdTime', value.holdTime) // 持仓汇总更新时间
                this.$store.commit('setH_orderTime', value.orderTime) // 委托更新时间
                this.$store.commit('setH_tradeTime', value.tradeTime) // 成交更新时间
                if (that.isFirstT) {
                  that.isFirstT = false
                }
                if (value.fuAccountFunds) {
                  this.fuAccountFunds = {
                    balance: value.fuAccountFunds.balance,
                    frozenFunds: value.fuAccountFunds.frozenFunds
                  }
                } else {
                  this.fuAccountFunds = {
                    balance: 0,
                    frozenFunds: 0
                  }
                }
              }, window.g.runloop_mongocache_time ? window.g.runloop_mongocache_time : 500)
            } else {
              this.fuAccountFunds = {
                balance: 0,
                frozenFunds: 0
              }
            }
          }
        } catch (e) {
          console.log(e)
          // this.runloopTimer = setTimeout(
          //   async() => {
          //     // sessionStorage.getItem('sessionStr') && sessionStorage.getItem('userId')
          //     await this.runloopQueryTradeClosepl()
          //   },
          //   window.g.APP_RUNLOOP_TRADE_ID ? window.g.APP_RUNLOOP_TRADE_ID : 3000
          // )
        }
      } else {
        that.isFirstT = true
      }
      if (this.runloopTimerStatus) {
        this.runloopTimer = setTimeout(
          async() => {
            // sessionStorage.getItem('sessionStr') && sessionStorage.getItem('userId')
            await this.runloopQueryTradeClosepl()
          },
          window.g.APP_RUNLOOP_TRADE_ID ? window.g.APP_RUNLOOP_TRADE_ID : 3000
        )
      }
    },
    // 查询市场信息
    param_queryContentSystem(values) {
      this.systemTime = values.systemTime
      this.$store.commit('setSystemTime', values.systemTime) // 更新系统时间 setSystemTime
      // O:开市准备中,T:交易中,P:休市中,R:准备结算中,E:结算中,C:闭市中
      switch (values.status) {
        case 'O':
          this.marketStatus = '闭市'
          // this.$store.commit('clearPriceDetail', [])
          // hqWs.send(hqProtocol.param_SYMBOLS)
          this.$store.commit('clearKlineCache') // 清空k线缓存
          break
        case 'T':
          this.marketStatus = '开市中'
          break
        case 'P':
          this.marketStatus = '交易暂停'
          break
        case 'R':
          this.marketStatus = '闭市'
          break
        case 'E':
          this.marketStatus = '闭市'
          break
        case 'C':
          this.marketStatus = '闭市'
          break
        default:
          this.marketStatus = '--'
          break
      }
      this.$store.commit('setMarketStatus', values)
      // 存储市场状态
      this.$store.commit('marketStatusInNewTopline', this.marketStatus)
      // 存储新公告id
      this.setNewNoticeID(values.content)
      // } else {
      //   this.marketStatus = '--'
      // }
      // })
    },
    // 查询持仓汇总
    showData() {
      this.isRiskRight = true
      const parms = JSON.parse(JSON.stringify(protocol.queryUserPositionSummariesNew))
      parms.data = {
        page: 0,
        size: 99999,
        firmId: this.sessionInfoGetter.firmId
      }
      http.gPost(parms).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.holdData = response.data.value.content
            this.calculate()
          } else {
            this.holdData = []
          }
        } else {
          this.holdData = []
        }
      }).catch((e) => {
        this.isRiskRight = false
        // setTimeout(() => {
        //   that.showData()
        // }, 1000)
      })
    },
    calculate() {
      var subscription = 0 // 占用履约金
      var holdPlSum = {
        holdPl: 0, // 货值变化总计
        currentHoldPl: 0 // 实时货值变化总计
      }
      const that = this
      this.each(this.holdData, function(arrIndex) {
        that.marketDetails.forEach(value => {
          if (value.symbolId == arrIndex.commodityId) {
            var MarketPrice = value.averagePrice.toFixed(that.coinSmallDigital(value).coinDigitalNum)
            if (that.marketStatusGetter.status === 'E' || that.marketStatusGetter.status === 'C') {
              arrIndex.currentHoldPl = arrIndex.hholdPl.toFixed(that.coinSmallDigital(value).coinDigitalNum)
            } else {
              // // avgPrice: 明细均价
              // arrIndex.currentHoldPl = arrIndex.bsFlag === 'B'
              //   ? (util.floatSub(value.close, arrIndex.avgPrice) * arrIndex.quantity * value.unitNumeral + arrIndex.hholdPl).toFixed(that.coinSmallDigital(value).coinDigitalNum)
              //   : (util.floatSub(arrIndex.avgPrice, value.close) * arrIndex.quantity * value.unitNumeral + arrIndex.hholdPl).toFixed(that.coinSmallDigital(value).coinDigitalNum)

              // totalPrice 总价
              arrIndex.currentHoldPl = arrIndex.bsFlag === 'B'
                ? (util.floatSub(value.close * arrIndex.quantity, arrIndex.totalPrice) * value.unitNumeral + arrIndex.hholdPl).toFixed(that.coinSmallDigital(value).coinDigitalNum)
                : (util.floatSub(arrIndex.totalPrice, value.close * arrIndex.quantity) * value.unitNumeral + arrIndex.hholdPl).toFixed(that.coinSmallDigital(value).coinDigitalNum)
            }
            MarketPrice = MarketPrice == 0 ? value.close.toFixed(that.coinSmallDigital(value).coinDigitalNum) : MarketPrice // 行情均价
            // initAvgPrice 订立均价
            arrIndex.holdPl = arrIndex.bsFlag === 'B'
              ? (util.floatSub(MarketPrice, arrIndex.initAvgPrice) * arrIndex.quantity * value.unitNumeral).toFixed(that.coinSmallDigital(value).coinDigitalNum)
              : (util.floatSub(arrIndex.initAvgPrice, MarketPrice) * arrIndex.quantity * value.unitNumeral).toFixed(that.coinSmallDigital(value).coinDigitalNum)
            subscription = util.floatAdd(subscription, arrIndex.holdMargin)
            holdPlSum.currentHoldPl = util.floatAdd(holdPlSum.currentHoldPl, arrIndex.currentHoldPl)
            holdPlSum.holdPl = util.floatAdd(holdPlSum.holdPl, arrIndex.holdPl)
            return
          }
        })
      })
      // 当前权益 = 当前余额 + 浮动盈亏
      const right = util.floatAdd(holdPlSum.currentHoldPl, this.fuAccountFunds.balance)
      // 可用资金 = 当前余额 - 冻结（当浮动盈亏小于0时加上浮动盈亏）
      let availableCapital = right - this.fuAccountFunds.frozenFunds
      if (holdPlSum.currentHoldPl > 0) {
        availableCapital = util.floatSub(availableCapital, holdPlSum.currentHoldPl)
      }
      // // 风险率 = 占用订货金/当前权益x100%
      // const risk = right != 0 ? subscription / right * 100 : 0
      // 风险率 = 当前权益/占用订货金x100%
      const risk = subscription != 0 ? (right / subscription * 100 > 9999.99 ? 9999.99 : right / subscription * 100) : 9999.99
      this.risk = risk >= 0 ? risk.toFixed(2) : 0
      this.$store.commit('setholdPlSum', holdPlSum)
      this.$store.commit('setRiskRight', { risk: this.risk, right: right })
      this.$store.commit('setH_avilibleMargin', availableCapital)
      this.isRiskRight = false
    },
    coinSmallDigital(s) {
      const minPriceChange = s.minPriceChange // 最小数量变动单位
      const minAmountChange = s.minAmountChange // 价格价格变动单位
      let pricePoint = -Math.round(Math.log(minPriceChange) / Math.log(10))
      let amountPoint = -Math.round(Math.log(minAmountChange) / Math.log(10))
      if (pricePoint <= 0) {
        pricePoint = 0
      }
      if (amountPoint <= 0) {
        amountPoint = 0
      }
      return {
        // //symbolId: this.item.symbolId,
        // numStr:/^(\d+)\.(\d{0,6}).*$/,
        numStr: new RegExp('^(\\d+)\\.(\\d{0,' + pricePoint + '}).*$'),
        coinDigitalNum: pricePoint,
        quantityNum: amountPoint, // 数量
        quantityStr: new RegExp('^(\\d+)\\.(\\d{0,' + amountPoint + '}).*$') // 数量
      }
    },
    // 存储新公告id
    setNewNoticeID(i) {
      let oldNotices = localStorage.getItem('tq_old_notice')

      if (this.isFirstN) {
        this.isFirstN = false
        localStorage.setItem('tq_old_notice', i)
        oldNotices = i
      }
      if (i == oldNotices) {
        return
      }
      let newNotices = JSON.parse(localStorage.getItem('tq_new_notice'))
      if (!newNotices) {
        newNotices = []
      }
      if (newNotices.indexOf(i) > -1) {
        return
      }
      newNotices.push(i)
      localStorage.setItem('tq_new_notice', JSON.stringify(newNotices))
      localStorage.setItem('tq_old_notice', i)
    },
    // 是否有新公告
    // isNewNotice() {
    //   const that = this
    //   this.timern = setTimeout(() => {
    //     if (localStorage.getItem('tq_new_notice')) {
    //       that.haveNewNotice = JSON.parse(
    //         localStorage.getItem('tq_new_notice')
    //       ).length
    //     } else {
    //       that.haveNewNotice = 0
    //     }
    //     that.isNewNotice()
    //   }, 1000)
    // },
    show: function() {},
    // 商品策略查询
    async queryCommodityStrategy() {
      const _this = this
      return http
        .postFront(protocol.param_queryCommodityStrategy)
        .then((response) => {
          const { code, message, value } = response.data
          if (code == 0) {
            this.$store.commit('setQueryTradeAuthArr', value)
            this.$store.commit('setCommodityStrategy', value)
            hqWs.send(hqProtocol.param_SYMBOLS)
            hqWs.send(hqProtocol.param_businessJb)
            return true
          } else {
            this.$message(message)
            setTimeout(() => {
              _this.queryCommodityStrategy()
            }, 1000)
            return false
          }
        })
        .catch((e) => {
          setTimeout(() => {
            _this.queryCommodityStrategy()
          }, 1000)
          return false
        })
    },
    logout() {
      protocol.param_logout.param.userid = this.sessionInfoGetter.userId
      http.postFront(protocol.param_logout).then(response => {
        const { code } = response.data
        if (code == '0') {
          this.$store.commit('setSessionInfo', '')
          this.$store.commit('marketStatusInNewTopline', '--')
          // 清除历史账号访问交易页面商品缓存信息
          this.$store.commit('item', {})
          sessionStorage.clear()
          this.queryCommodityStrategy()
          this.$router.push('/')
        }
      })
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale = localStorage.lang || 'cn'
      switch (localStorage.lang) {
        case 'en':
          {
            this.downLoadCss = true
            const msgSpanCss = {
              MidLongTermSpanCss: 4,
              LoginSpanCss: 12
            }
            localStorage.setItem('msgSpanCss', JSON.stringify(msgSpanCss))
            this.msgSpanCss = JSON.parse(localStorage.msgSpanCss)
          }
          break
        default:
          break
      }
    },
    // 查询站内信信息
    isReadFlag() {
      protocolTrans.param_transferMsgInfo.param.size = 10
      protocolTrans.param_transferMsgInfo.param.page = 0
      protocolTrans.param_transferMsgInfo.param.readFlag = 'N'
      http.postFront(protocolTrans.param_transferMsgInfo).then((response) => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value.content) {
            this.dataList = value.content
            this.showDialog()
          }
        } else {
          Toast(message)
        }
      })
    },
    showDialog() {
      // 多条数据的情况下需要一条一条展示，上一条关闭时打开下一个弹框
      // 展示的时候就调取已读接口
      if (this.dataList.length !== 0) {
        this.formData = this.dataList[0]
        if (this.isSureLoginMsg()) { // 已经同意登录风险告知书
          this.dialogVisible = true
          // console.log(this.dataList[0].inMsgId)
          this.yReadFlag(this.dataList[0].inMsgId)
        }
      }
    },
    isSureLoginMsg() {
      const firmId = this.$store.state.common.sessionInfo.firmId
      const time = new Date()
      const timer = util.formatnewDay(time)
      const obj = {}
      obj.firmId = firmId
      obj.time = timer
      const content = JSON.parse(localStorage.getItem('userList')) || []
      if (content.length !== 0) {
        let m = 0
        for (let i = 0; i < content.length; i++) {
          if (content[i].firmId === firmId) {
            content.splice(i, 1)
            content.push(obj)
          } else {
            m = m + 1
          }
        }
        if (m === content.length) {
          content.push(obj)
          return false
        }
      } else {
        content.push(obj)
        return false
      }
      return true
    },
    handleClose() {
      // 删除数组的第一个元素
      this.dataList.shift()
      this.dialogVisible = false
      // 进行循环，如果还有数据，继续展示
      const that = this
      setTimeout(function() {
        if (that.dataList.length !== 0) {
          that.showDialog()
        }
      }, 500)
    },
    // 站内信已读
    yReadFlag(id) {
      protocolTrans.param_updateInMsgReadFlag.param.id = id
      http.postFront(protocolTrans.param_updateInMsgReadFlag).then((response) => {
        const { code, message } = response.data
        if (code === 0 || code === '0') {
          // console.log(value)
        } else {
          Toast(message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#myheader {
  // height: 100px;
  box-sizing: border-box;
  min-width: 1200px;
  padding:  14px 60px 14px 38px;
  // 共同字体颜色
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 12px;
  color: #989898;
  .headerWrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .headerLeft {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logoImg {
        width: 32px;
        height: 32px;
        margin-right: 12px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .logoTitle {
        font-family: Source Han Sans SC;
        font-weight: 800;
        font-size: 16px;
        color: #FFFFFF;
      }
      .line {
        width: 1px;
        height: 24px;
        background: #DDDDDD;
        margin: 0 17px 0 31px;
      }
      .headerTitle {
        line-height: 32px;
        // margin-right: 28px;
        font-size: 14px;
        a {
          display: inline-block;
          height: 32px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          font-size: 14px;
          color: #989898;
          padding: 0 14px;
        }
        span {
          padding: 0 14px;
          display: inline-block;
          height: 32px;
          cursor: pointer;
        }
      }
      .activeTitle {
        color: #FFFFFF;
      }
    }
    .headerRight {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .rightIcon {
        width: 18px;
        height: 18px;
        margin-right: 14px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.userDropdown {
  padding: 28px 10px 0;
  .cellphone {
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    text-align: center;
    margin-bottom: 22px;
  }
  .el-dropdown-menu__item {
    padding: 0;
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    width: 162px;
    margin: 0 auto;
    height: 28px;
    line-height: 28px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 15px;
      height: 15px;
      margin-right: 10px;
    }
    .itemTitle {
      width: 84px;
    }
  }
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
    border-radius: 4px;
    background-color: #E5E5E5;
    color: #333333;
  }
}
.QRcode {
  padding: 29px;
  text-align: center;
  .codeTitle {
    font-family: Source Han Sans SC;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
    margin-bottom: 24px;
  }
  img {
    width: 138px;
    height: 138px;
    border-radius: 6px;
  }
}
.tipHeight{
  max-height: 50vh;
  overflow-y: scroll
}
</style>
